// extracted by mini-css-extract-plugin
export var createdDate = "_ih-1";
export var divider = "_ih-2";
export var headerDivider = "_ih-3";
export var messagesCard = "_ih-0";
export var messagesContainer = "_ih-7";
export var messagesContainerWrapper = "_ih-4";
export var pointerCapturingButtonBoxes = "_ih-a";
export var showLeftPanelButton = "_ih-9";
export var showMoreButton = "_ih-c";
export var showMoreButtonContainer = "_ih-b";
export var summaryTitle = "_ih-6";
export var systemMessageCardWrapper = "_ih-d";
export var topButtons = "_ih-8";
export var withPadding = "_ih-5";